import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import * as FreudDS from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { OfficeModalModule } from '@office-ui/modal/modal.module';
import { AppointmentSidebarModule } from 'modules/appointments/components/appointment-sidebar/appointment-sidebar.module';
import { AppointmentTypeBadgeModule } from 'modules/appointments/components/appointment-type-badge/appointment-type-badge.module';
import { EvaluationAnswerCardModule } from 'modules/evaluations/components/evaluation-answer-card/evaluation-answer-card.module';
import { EvaluationAnswerDetailModule } from 'modules/evaluations/components/evaluation-answer-detail/evaluation-answer-detail.module';
import { ExportModalModule } from 'modules/exports/components/export-modal/export-modal.module';
import { JourneyOverviewModule } from 'modules/journeys/components/journey-overview/journey-overview.module';
import { NgxMaskModule } from 'ngx-mask';
import { TooltipModule } from 'primeng/tooltip';
import { TabsRowModule } from 'shared/components/tabs-row/tabs-row.module';
import { ContactService } from 'shared/services/contact/contact.service';
import { SharedModule } from 'shared/shared.module';

import { EvaluationsService } from './../evaluations/services/evaluations.service';
import { ContactContent } from './components/contact-content/contact-content.component';
import { ContactFollowUpModule } from './components/contact-follow-up/contact-follow-up.module';
import { ContactIbc } from './components/contact-ibc/contact-ibc.component';
import { ContactNotes } from './components/contact-notes/contact-notes.component';
import { ContactPage } from './components/contact-page/contact-page.component';
import { ContactPromptuariesFilterModule } from './components/contact-promptuaries-filter/contact-promptuaries-filter.module';
import { ContactPromptuaries } from './components/contact-promptuaries/contact-promptuaries.component';
import { ContactTests } from './components/contact-tests/contact-tests.component';
import { ContactsListPageModule } from './components/contacts-list-page/contacts-list-page.module';
import { MoodTrackerReportCardModule } from './components/moodtracker-report-card/moodtracker-report-card.module';
import { ContactsRoutes } from './contacts.routes';
import { CoeNotesService } from './services/coe-notes.service/coe-notes.service';

registerLocaleData(localePt);

@NgModule({
	declarations: [
		ContactContent,
		ContactIbc,
		ContactNotes,
		ContactPage,
		ContactTests,
		ContactPromptuaries,
	],
	imports: [
		CommonModule,
		FreudDS.FreudDialogModule,
		FreudDS.FreudButtonModule,
		FreudDS.FreudCardModule,
		FreudDS.FreudLoaderModule,
		FreudDS.FreudLoaderModule,
		FreudDS.FreudSelectModule,
		FreudDS.FreudTagModule,
		FreudDS.FreudTooltipModule,
		FreudDS.FreudTypographyModule,
		NgxMaskModule.forChild(),
		OfficeModalModule,
		RouterModule.forChild(ContactsRoutes),
		SharedModule,
		TooltipModule,
		TranslateModule.forChild(),
		MoodTrackerReportCardModule,
		JourneyOverviewModule,
		EvaluationAnswerCardModule,
		EvaluationAnswerDetailModule,
		ExportModalModule,
		TabsRowModule,
		AppointmentTypeBadgeModule,
		ContactsListPageModule,
		AppointmentTypeBadgeModule,
		ContactPromptuariesFilterModule,
		AppointmentSidebarModule,
		ContactFollowUpModule,
	],
	providers: [
		{ provide: LOCALE_ID, useValue: 'pt-BR' },
		CoeNotesService,
		ContactService,
		EvaluationsService,
	],
	entryComponents: [ContactPage],
})
export class ContactsModule {}
